import type { ComponentType } from 'react';
import { resolveClient, UnknownClientError, type ClientRegistry, type SiteRendererProps } from './registry';

export type LoadRendererResult = {
  Renderer: ComponentType<SiteRendererProps>;
  fellBack: boolean;
  error?: unknown;
};

export type RenderErrorLogger = (params: {
  tenantId: string;
  siteAppKey: string;
  domain: string;
  error: unknown;
  stage: 'resolve' | 'import' | 'render';
}) => Promise<void> | void;

export async function loadSiteRenderer(
  registry: ClientRegistry,
  props: Pick<SiteRendererProps, 'siteAppKey' | 'tenantId' | 'domain'>,
  fallback: ComponentType<SiteRendererProps>,
  logError?: RenderErrorLogger,
): Promise<LoadRendererResult> {
  try {
    const entry = resolveClient(registry, props.siteAppKey);
    const mod = await entry.siteRenderer();
    return { Renderer: mod.default, fellBack: false };
  } catch (error) {
    const stage: 'resolve' | 'import' = error instanceof UnknownClientError ? 'resolve' : 'import';
    if (logError) {
      try {
        await logError({
          tenantId: props.tenantId,
          siteAppKey: props.siteAppKey,
          domain: props.domain,
          error,
          stage,
        });
      } catch {
        // never throw from the error path
      }
    }
    return { Renderer: fallback, fellBack: true, error };
  }
}
